export const environment = {
  production: true,
  title: 'Production Environment Heading',
  apiURL: 'https://toherba.kuvesoft.com:4300/'
};
